<template>
  <div class="banner-content">
    <div class="bg-image" :style="'background-image: url(' + imgIp + url + ')'">
      <div class="home-title">
        <div v-if="attrName" class="little-web-name">维才考考试平台</div>
        <div v-else class="web-name">维才考考试平台</div>
        <div class="attr-name">{{attrName}}</div>
      </div>
    </div>
  </div>
</template>

<script>
import config from '@/utils/index'
export default {
  name: 'LittleBanner',
  props: {
    "attrName": {
      type: String
    }
  },
  data() {
    return {
      imgIp: config.imgIp,
      url: this.$store.state.app.homeBg
    }
  }
}
</script>

<style lang="scss" scoped>
.banner-content {
  background-color: #fff;
  padding: 0 24px 24px;
}
.bg-image {
  min-height: 196px;
  background-image: url('~@/assets/bg.png');
  background-position: center;
  background-size: cover;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 16px;
  position: relative;
  .home-title {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    font-size: 42px;
    color: #fff;
    background: linear-gradient(225deg, rgba(53, 109, 143, 0.25) 0%, rgba(24, 59, 86, 0.75) 100%);
    font-weight: 600;
    border-radius: 16px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    text-align: center;
    .web-name {
      width: 460px;
      text-align: center;
    }
    .little-web-name {
      width: 100%;
      font-size: 14px;
    }
    .attr-name {
      font-size: 42px;
    }
  }
}
</style>
